import React from "react";
import CommonSummary from "../../../CommonComponent/CommonSummary";
import { useSelector } from "react-redux";
import _ from "underscore";
export var EHoldingSummaryField;
(function (EHoldingSummaryField) {
    EHoldingSummaryField[EHoldingSummaryField["TOTAL_INVESTMENT"] = 0] = "TOTAL_INVESTMENT";
    EHoldingSummaryField[EHoldingSummaryField["CURRENT_VALUE"] = 1] = "CURRENT_VALUE";
    EHoldingSummaryField[EHoldingSummaryField["TOTAL_PNL"] = 2] = "TOTAL_PNL";
    EHoldingSummaryField[EHoldingSummaryField["DAYS_PNL"] = 3] = "DAYS_PNL";
})(EHoldingSummaryField || (EHoldingSummaryField = {}));
const HoldingSummary = (props) => {
    const { HoldingSummary: holdingSummary } = useSelector((state) => { var _a; return (_a = state.holdingReport) === null || _a === void 0 ? void 0 : _a.data; }, _.isEqual);
    // React.useEffect(() => {
    //   if (
    //     holdingSummary?.date ||
    //     holdingSummary?.totalInvestment ||
    //     holdingSummary?.totalPnL
    //   ) {
    //     props.setLoader(false);
    //   }
    // }, [holdingSummary]);
    return (React.createElement("div", null,
        React.createElement(CommonSummary, { summaryData: [
                {
                    title: "Total Investment",
                    value: holdingSummary === null || holdingSummary === void 0 ? void 0 : holdingSummary.totalInvestment.toString(),
                    integer: false,
                    externalClassName: "holding_summary",
                    summaryField: EHoldingSummaryField.TOTAL_INVESTMENT,
                },
                {
                    title: "Current Value",
                    value: holdingSummary === null || holdingSummary === void 0 ? void 0 : holdingSummary.currentValue.toString(),
                    integer: false,
                    externalClassName: "holding_summary",
                    summaryField: EHoldingSummaryField.CURRENT_VALUE,
                },
                {
                    title: "Total P&L",
                    value: holdingSummary === null || holdingSummary === void 0 ? void 0 : holdingSummary.totalPnL.toString(),
                    percentageValue: holdingSummary === null || holdingSummary === void 0 ? void 0 : holdingSummary.totalPnLChange.toString(),
                    integer: true,
                    externalClassName: "holding_summary",
                    summaryField: EHoldingSummaryField.TOTAL_PNL,
                },
                {
                    title: "Day's P&L",
                    value: holdingSummary === null || holdingSummary === void 0 ? void 0 : holdingSummary.daysPnL.toString(),
                    percentageValue: holdingSummary === null || holdingSummary === void 0 ? void 0 : holdingSummary.daysPnLChange.toString(),
                    integer: true,
                    externalClassName: "holding_summary background_blue",
                    summaryField: EHoldingSummaryField.DAYS_PNL,
                },
            ], dock: props.scrollPosition > 20 ? true : false, keyTab: props === null || props === void 0 ? void 0 : props.keyTab })));
};
export default React.memo(HoldingSummary);
